import Constants from './constants';
import { FETCH_UPDATE, FETCH_SUCCESS, FETCH_FAILURE } from '@/store/actions';
/**
 * Method generates multiple mutation object mapped to the callback.
 * This method is similar to below example.
 *
 * Switch(_mutations) {
 *  case MutationCase1:
 *  case MutationCase2:
 *  case MutationCase3:
 *      callback();
 *      break;
 * }
 *
 * @param Array _mutations
 * @param Function callback
 * @param Object mutations
 */
export function mutationMapper (_mutations, _callback) {
    const _mappedMutation = {};
    _mutations.forEach(mutation => _mappedMutation[mutation] = _callback);
    return _mappedMutation;
}

/**
 * Method accepts all the parent mutation key, internally it
 * will create mapper for SUCCESS and FAILURE keys.
 * @param Array _mutations
 * @param Function callback
 * @param Object _mutations
 */
export function loaderMutationMapper (_mutations, _callback) {
    const _loaderMutation = [];
    _mutations.forEach(_mutation => {
        _loaderMutation.push(_mutation, `${_mutation}_SUCCESS`, `${_mutation}_FAILURE`);
    });

    return mutationMapper(_loaderMutation, _callback);
}

export function globalCommit (_namespace, commit, _type, _payload = null) {
    commit(`${_namespace}/${_type}`, _payload, { root: true });
}

export function globalDispatch (_namespace, dispatch, _type, _payload = null) {
    return dispatch(`${_namespace}/${_type}`, _payload, { root: true });
}

export function commitLocalAndToGlobalService (commit, _type, _payload) {
    const _actionType = getServiceMutationType(_type);
    commit(_type, _payload);
    globalCommit('service', commit, _actionType, _payload);
}

export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function getServiceMutationType (_mutation) {
    const _item = _mutation.split('_');
    const _type = _item[_item.length - 1];

    switch (_type.toLowerCase()) {
        case Constants.ServiceMutationTypes.Success:
            return FETCH_SUCCESS;
        case Constants.ServiceMutationTypes.FAILURE:
            return FETCH_FAILURE;
        default:
            return FETCH_UPDATE;
    }
}
